/**
 * Lite 訂閱相關共用常數與判斷（SSOT）
 * 與後端 lite-constants 對齊：付費方案 slug 僅 basic / plus / pro
 */

/** 付費方案 slug（與後端 lite-constants 一致） */
export const LITE_PAID_PLAN_SLUGS: readonly string[] = [
  'basic',
  'plus',
  'pro',
] as const;

export type LitePaidPlanSlug = (typeof LITE_PAID_PLAN_SLUGS)[number];

/**
 * 是否為 Lite 付費方案（basic / plus / pro）
 */
export function isLitePaidPlan(planSlug: string): boolean {
  return LITE_PAID_PLAN_SLUGS.includes(planSlug);
}
